const deviceRootUrl = "Device";

const devicePairingUrl = "DevicePairing";

const getDeviceList = `${deviceRootUrl}/list`;

const deviceConfigUrl = "DeviceConfig";

export default {
  deviceRootUrl,
  devicePairingUrl,
  getDeviceList,
  deviceConfigUrl
};
